import { AdminBarberRepository } from "../../Repository";

export async function clickOnLogin(
  userEmail: string,
  userPassword: string,
  repository: AdminBarberRepository
): Promise<boolean> {
  return repository.login(userEmail, userPassword);
}
